import { Box, Typography } from "@mui/material";
import { FAQs } from "../../utils/data/Landing-Page/data";
import { CTA, FAQ } from "./LandingPageElements";



export const SeventhPage = () => {
    return (
        <Box sx={{ background: '#fff' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', width: '80%', py: 3 }}>
                    <Typography sx={{ fontSize: '20px', color: '#0057D5', fontWeight: '700', py: 4 }}>FAQ</Typography>
                    <Typography sx={{ fontSize: '40px', color: '#040815', fontWeight: '700', py: 2 }}>Frequently Asked Questions</Typography>
                    <Typography sx={{ fontSize: '20px', color: '#474747', fontWeight: '500', py: 2 }}>Everything you need to know about the product.</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', my: 4 }}>
                        {FAQs.map((e, i) => (
                            <FAQ key={i} e={e} i={i} />
                        ))}
                    </Box>
                    <CTA />
                </Box>
            </Box>
        </Box>
    );
}